import { defineStore } from "pinia";

export const useBoardingTaskStore = defineStore('boardingTask', {
  state: () => ({
    boardingTask: {},
    boardingTasks: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setBoardingTask(boardingTask) {
      this.boardingTask = boardingTask
    },
    setBoardingTasks(boardingTasks) {
      this.boardingTasks = boardingTasks
    },
    addBoardingTask(boardingTask) {
      this.boardingTasks.unshift(boardingTask)
    },
    updateBoardingTask(boardingTask) {
      let index = this.boardingTasks.findIndex(cl => cl.id === boardingTask.id)
      this.boardingTasks.splice(index, 1, boardingTask)
    },
    deleteBoardingTask(boardingTask) {
      let index = this.boardingTasks.findIndex(cl => cl.id === boardingTask.id)
      this.boardingTasks.splice(index, 1)
    },
  },
});